import React from 'react'
import './Home.css'
function Home() {
  return (
    <div className='home'>
      <h1 className='home-title'>Welcome To Game Switch NYC!</h1>
      <br></br>
      {/* <span class='start-btn'>START</span> */}
      <h2>Sign up or Log in to get started</h2>

      {/* <img width="400" src="https://media2.giphy.com/media/fAD9SMlNWp0k84Ra1G/giphy.gif?cid=790b7611d3fec240996c139a98fa99ad753b3ea083818e0e&rid=giphy.gif&ct=g"></img>   */}
      <img src='https://cdn.dribbble.com/users/989157/screenshots/3825479/comp-4_1.gif' />
    </div>
  )
}
export default Home
